import { render, staticRenderFns } from "./epros.vue?vue&type=template&id=5b3101b8&scoped=true&"
import script from "./epros.vue?vue&type=script&lang=js&"
export * from "./epros.vue?vue&type=script&lang=js&"
import style0 from "./epros.vue?vue&type=style&index=0&id=5b3101b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3101b8",
  null
  
)

component.options.__file = "epros.vue"
export default component.exports